import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import omitBy from 'lodash.omitby'
import isEmpty from 'lodash.isempty'
import {
  adaptPassesToStore,
  adaptPassToApi
} from './adapters/passAdapter'
import { CONTENT } from '@/services/axios.config'

const services = [
  {
    name: 'listPasses',
    method: 'get',
    url: (params) => `/passes${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptPassesToStore
  },
  {
    name: 'getPass',
    method: 'get',
    url: (params) => `/passes/${params.passId}`
  },
  {
    name: 'createPass',
    method: 'post',
    url: () => `/passes`,
    data: (params) => {
      return adaptPassToApi(params)
    },
  },
  {
    name: 'editPass',
    method: 'put',
    url: (params) => `/passes/${params.passId}`,
    data: (params) => {
      return adaptPassToApi(params)
    },
  },
  {
    name: 'addCourseToPass',
    method: 'post',
    url: (params) => `/passes/${params.passId}/courses`,
    data: (params) => {
      return {
        courses: params.course_ids
      }
    }
  },
  {
    name: 'deleteCourseToPass',
    method: 'delete',
    url: (params) => `/passes/${params.passId}/courses/${params.courseId}`
  },
  {
    name: 'addLPathToPass',
    method: 'post',
    url: (params) => `/passes/${params.passId}/learning-paths`,
    data: (params) => {
      return {
        learning_paths: params.lpath_ids
      }
    }
  }, {
    name: 'deleteLPathToPass',
    method: 'delete',
    url: (params) => `/passes/${params.passId}/learning-paths/${params.lpathId}`
  },
  {
    name: 'addBootcampToPass',
    method: 'post',
    url: (params) => `/passes/${params.passId}/bootcamps`,
    data: (params) => {
      return {
        bootcamps: params.bootcamp_ids
      }
    }
  }, {
    name: 'deleteBootcampToPass',
    method: 'delete',
    url: (params) => `/passes/${params.passId}/bootcamps/${params.bootcampId}`
  }
]

export const {
  listPasses,
  getPass,
  createPass,
  editPass,
  addCourseToPass,
  deleteCourseToPass,
  addLPathToPass,
  deleteLPathToPass,
  addBootcampToPass,
  deleteBootcampToPass,
} = buildServices(CONTENT, services)